export const toggleableRecurrenceFormControls = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  'ByDay',
  'ByMonthWithDay',
  'ByMonthWithOffset',
  'ByMonthDay',
  'Offset',
];

export enum ReportFrequency {
  Weekly = 'Weekly',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Yearly = 'Yearly',
}

export enum WeekdaysFormKeys {
  Mon = '1',
  Tue = '2',
  Wed = '3',
  Thu = '4',
  Fri = '5',
  Sat = '6',
  Sun = '0',
}

export const FullWeekdaysTranslationKeys: { [key: string]: string } = {
  '1': 'General.DaysOfWeek.Monday',
  '2': 'General.DaysOfWeek.Tuesday',
  '3': 'General.DaysOfWeek.Wednesday',
  '4': 'General.DaysOfWeek.Thursday',
  '5': 'General.DaysOfWeek.Friday',
  '6': 'General.DaysOfWeek.Saturday',
  '0': 'General.DaysOfWeek.Sunday',
};
